export default __webpack_public_path__ + "static/media/wine-accessories.3abd85ba.svg";